import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAlertTriangle, FiAlertCircle, FiClock } from 'react-icons/fi';

const AlertsPanel = ({ alerts }) => {
  const getAlertIcon = (level) => {
    switch (level) {
      case 'alert': return <SafeIcon icon={FiAlertTriangle} className="text-red-500" />;
      case 'watch': return <SafeIcon icon={FiAlertCircle} className="text-yellow-500" />;
      default: return <SafeIcon icon={FiClock} className="text-blue-500" />;
    }
  };

  const getAlertBg = (level) => {
    switch (level) {
      case 'alert': return 'bg-red-50 border-red-200';
      case 'watch': return 'bg-yellow-50 border-yellow-200';
      default: return 'bg-blue-50 border-blue-200';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
        <SafeIcon icon={FiAlertTriangle} className="text-red-500" />
        Active Coral Bleaching Alerts
      </h2>
      
      <div className="space-y-3">
        {alerts.map((alert, index) => (
          <div key={index} className={`p-4 rounded-lg border ${getAlertBg(alert.level)}`}>
            <div className="flex items-start gap-3">
              {getAlertIcon(alert.level)}
              <div className="flex-1">
                <div className="flex justify-between items-start">
                  <h3 className="font-semibold text-gray-800">{alert.cityName}</h3>
                  <span className="text-sm text-gray-600">
                    {new Date(alert.timestamp).toLocaleString('en-PH')}
                  </span>
                </div>
                <p className="text-sm text-gray-700 mt-1">{alert.message}</p>
                <div className="flex gap-4 mt-2 text-sm text-gray-600">
                  <span>Temperature: {alert.temperature}°C</span>
                  <span>Duration: {alert.duration}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertsPanel;